/**
 * RPR-6678: Mux video playback token fetcher.
 *
 * Wraps GET /api/video/<id>/playback-token/. Used by the rpr-video-player
 * directive (Phase C2) to mint a short-lived signed JWT before mounting
 * <mux-player>.
 *
 * The endpoint accepts both payers (via PayerAssignedSurvey) and authoring
 * users (for documents they own). The portal speaks to it only from the
 * authoring side; the payer-portal Angular app calls the same endpoint
 * with the payer auth.
 */
app.factory('videoPlaybackService',
  ['$q', 'apiHelper', 'HttpAuth',
    function ($q, apiHelper, HttpAuth) {
      function getPlaybackToken(documentId) {
        const url = apiHelper.getApiUrl() + '/api/video/' + encodeURIComponent(documentId) + '/playback-token/';
        return $q(function (resolve, reject) {
          HttpAuth.get(url).then(function (response) {
            const body = response?.data || {};
            if (!body.playback_id || !body.playback_token) {
              reject({ status: response?.status, detail: 'Empty playback token payload' });
              return;
            }
            resolve({
              playbackId: body.playback_id,
              playbackToken: body.playback_token,
              drmLicenseToken: body.drm_license_token || null,
              drmEnabled: !!body.drm_enabled
            });
          }, function (err) {
            // 404 here means the user is not authorized for this video,
            // the document is not a video, or the asset is not yet
            // ready. Bubble up so the directive can render a fallback.
            reject({
              status: err?.status,
              detail: err?.data?.detail || 'Failed to fetch playback token'
            });
          });
        });
      }

      // RPR-6700: presigned S3 URL for the original upload, so the authoring
      // portal can play an evicted ("archived") video directly from S3 without
      // triggering a Mux restore. Author/admin-only on the backend.
      function getSourceUrl(documentId) {
        const url = apiHelper.getApiUrl() + '/api/video/' + encodeURIComponent(documentId) + '/source-url/';
        return $q(function (resolve, reject) {
          HttpAuth.get(url).then(function (response) {
            const body = response?.data || {};
            if (!body.source_url) {
              reject({ status: response?.status, detail: 'Empty source url payload' });
              return;
            }
            resolve({ sourceUrl: body.source_url });
          }, function (err) {
            reject({
              status: err?.status,
              detail: err?.data?.detail || 'Failed to fetch source url'
            });
          });
        });
      }

      return {
        getPlaybackToken: getPlaybackToken,
        getSourceUrl: getSourceUrl
      };
    }
  ]
);
